/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class ExtCustomerActivityClientService extends __BaseService {
  static readonly AddEndConversationEventRecordByEntityidGETPath = '/api/ExtCustomerActivity/AddEndConversationEventRecord/{entityId}';
  static readonly IsAutoAssistantConversationOpenByEntityidGETPath = '/api/ExtCustomerActivity/IsAutoAssistantConversationOpen/{entityId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param entityId undefined
   * @return Success
   */
  AddEndConversationEventRecordByEntityidGETResponse(entityId: string): __Observable<__StrictHttpResponse<number>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExtCustomerActivity/AddEndConversationEventRecord/${entityId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: parseFloat((_r as HttpResponse<any>).body as string) }) as __StrictHttpResponse<number>
      })
    );
  }
  /**
   * @param entityId undefined
   * @return Success
   */
  AddEndConversationEventRecordByEntityidGET(entityId: string): __Observable<number> {
    return this.AddEndConversationEventRecordByEntityidGETResponse(entityId).pipe(
      __map(_r => _r.body as number)
    );
  }

  /**
   * @param entityId undefined
   * @return Success
   */
  IsAutoAssistantConversationOpenByEntityidGETResponse(entityId: string): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/ExtCustomerActivity/IsAutoAssistantConversationOpen/${entityId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param entityId undefined
   * @return Success
   */
  IsAutoAssistantConversationOpenByEntityidGET(entityId: string): __Observable<boolean> {
    return this.IsAutoAssistantConversationOpenByEntityidGETResponse(entityId).pipe(
      __map(_r => _r.body as boolean)
    );
  }
}

module ExtCustomerActivityClientService {
}

export { ExtCustomerActivityClientService }
